'use client';

import { useEffect, useSyncExternalStore } from 'react';

import { getClientExperimentRuntime } from '@lib/client-experiments';
import { trackEnrollment } from '@lib/tracking';

const subscribe = (listener: () => void) =>
  getClientExperimentRuntime()?.subscribe(listener) ?? (() => {});
const getServerSnapshot = () => null;

export const useSeedExperiment = (name: string): string | null => {
  const cohort = useSyncExternalStore(
    subscribe,
    () => getClientExperimentRuntime()?.resolve(name) ?? null,
    getServerSnapshot,
  );

  useEffect(() => {
    if (cohort !== null) {
      const runtime = getClientExperimentRuntime();
      if (runtime?.ready(name, cohort)) runtime.expose(name, trackEnrollment);
    }
  }, [name, cohort]);

  return cohort;
};
